import { CustomComponentProps } from "utils/types/generalTypes";
import SVG from "../core/SVG";
import RadioBtn from "../core/RadioBtn";

export type SettingsRadioProps = CustomComponentProps & {
    svg: string;
    title: string;
    details: string;
    checked: boolean;
    handleClick: React.Dispatch<
        React.SetStateAction<"no-one" | "followers" | "selected-followers">
    >;
};

const SettingsRadio = ({
    svg,
    title,
    details,
    checked,
    handleClick,
    className,
    style
}: SettingsRadioProps) => {
    return (
        <div
            className={`settings-item d-flex flex-j-start w-full flex-a-center gap-10 pt-20 pl-10 pr-10 w-full ${className}`}
            style={style}
        >
            <SVG svg={svg} size={24} style={{ minWidth: "25px" }} />
            <div className="settings-item-text d-flex flex-j-center flex-a-start flex-col gap-5">
                <span className="settings-h2 fw-500 black-text white-text">
                    {title}
                </span>
                <span className="settings-detail momeento-p grey-text">
                    {details}
                </span>
            </div>
            <RadioBtn
                name="msg-radio"
                handleClick={handleClick}
                checked={checked}
                color=""
                className="ml-auto"
            />
        </div>
    );
};

export default SettingsRadio;
